export function checkResultLine() {
    $('.answers.result').each(function () {
        var area = $(this);
        if (area.length > 0 && !area.hasClass('loaded')) {
            if (area.isInViewport()) {
                area.find('.result_line_active').each(function () {
                    $(this).animate({
                        width: $(this).data('width')
                    });
                });
                area.addClass('loaded');
            }
        }
    });
}


